import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormControlledInput from "./FormControlledInput";
import { FormProps } from "./FormProps";
import { Translation } from "../TranslationWrapper/TranslationWrapper";
import { ControllerProps } from "react-hook-form";
import { TextFieldProps } from "@mui/material";

function FormControlledInputTC(
  props: FormProps & Translation & { rules?: ControllerProps["rules"] } & { fieldProps?: TextFieldProps }
) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormControlledInput fieldProps={props.fieldProps ?? {}} name={props.name} options={props.options} />
    </FormFieldTwoColumns>
  );
}

FormControlledInputTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  type: PropTypes.string,
  suffix: PropTypes.string,
  nullable: PropTypes.bool,
};

FormControlledInputTC.defaultProps = {};

export default FormControlledInputTC;
